import fondo from  '../../assets/images/fondo.png';
import { useEffect } from 'react';

const Fondo = ({ style = {}, classes = [], children, flex }) => {
      
    useEffect(() => {
        document.documentElement.style.margin = '0';
        document.documentElement.style.padding = '0';
        document.documentElement.style.width = '100%';
        document.documentElement.style.height = '100%';
        document.documentElement.style.overflow = 'hidden';

        document.body.style.margin = '0';
        document.body.style.padding = '0';
        document.body.style.width = '100%';
        document.body.style.height = '100%';
        document.body.style.overflow = 'hidden';

        const root = document.getElementById('root');
        if (root) {
            root.style.margin = '0';
            root.style.padding = '0';
            root.style.width = '100%';
            root.style.height = '100%';
            root.style.overflow = 'hidden';
        }

        document.documentElement.style.boxSizing = 'border-box';
        document.body.style.boxSizing = 'border-box';
        document.querySelectorAll('*').forEach(el => {
            el.style.boxSizing = 'inherit';
        });
    }, []);
  return (
      <div
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundImage: `url(${fondo})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        overflow: 'auto',
      }}
    >
      {children}
    </div>
  );
};

export const Background = ({ style = {}, classes = [], children, flex }) => (
    <div style={{width: '100%', height: '100vh'}}>
        <Fondo {...{ style, classes: [...classes, 'stack'], children, flex }}/>
    </div>
);
